import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { selectInstruments } from '@app/core/store/capital-structure-slice-selectors';
import { TargetMetric } from '../models/contracts/enums/shared-enums';
import { enumKeyByValue } from '../helpers';

const useIsIrrTranchePresent = () => {
  const instruments = useAppSelector(selectInstruments);
  const institutionalIrrKey = enumKeyByValue(TargetMetric, TargetMetric.InstitutionalIRR);

  const isIrrTranchePresent = instruments.some(
    (instrument) =>
      Array.isArray(instrument.payoutLogic) &&
      instrument.payoutLogic.some(
        (payout) =>
          Array.isArray(payout.conditions) &&
          payout.conditions.some((condition) => condition.targetMetric === institutionalIrrKey)
      )
  );

  return isIrrTranchePresent;
};

export default useIsIrrTranchePresent;
